import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid'
import { DatePicker, SelectBox, TextInput } from '@tecuity/granite-ui'
import { SetSelectedBatches, GetAndSetBatches, GetAndSetBatchTypes } from '../PostPaymentActions'
import CalendarIcon from '@tecuity/sos-icons/react/calendar'
import format from 'date-fns/format'

const PostPaymentBatch = () => {
  const dispatch = useDispatch()
  const [throughDate, setThroughDate] = useState(format(new Date(), 'MM/dd/yyyy'))
  const [showThroughDate, setShowThroughDate] = useState(false)
  const { batches, batchTypes } = useSelector((state) => state.postPayment, shallowEqual)
  const [/*batchType,*/ setBatchType] = useState([])
  const [selectedRows, setSelectedRows] = useState([])

  const tableColumnsBatches = [
    { field: 'batchNum', flex: 0.2, minWidth: 20, headerName: 'Batch #', disableColumnMenu: true },
    { field: 'user', flex: 0.2, minWidth: 20, headerName: 'User', disableColumnMenu: true },
    {
      field: 'amount',
      flex: 0.2,
      minWidth: 20,
      headerName: 'Amount',
      disableColumnMenu: true,
      renderCell: (params) => {
        return `$${(params.row.amount || 0)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
      },
    },
    {
      field: 'closedDate',
      flex: 0.2,
      minWidth: 20,
      headerName: 'Closed Date',
      disableColumnMenu: true,
    },
    { field: 'status', flex: 0.2, minWidth: 20, headerName: 'Status', disableColumnMenu: true },
  ]

  const tableColumnsBatches_AmountDisabled = [
    { field: 'batchNum', flex: 0.2, minWidth: 20, headerName: 'Batch #', disableColumnMenu: true },
    { field: 'user', flex: 0.2, minWidth: 20, headerName: 'User', disableColumnMenu: true },
    {
      field: 'closedDate',
      flex: 0.2,
      minWidth: 20,
      headerName: 'Closed Date',
      disableColumnMenu: true,
    },
    { field: 'status', flex: 0.2, minWidth: 20, headerName: 'Status', disableColumnMenu: true },
  ]

  useEffect(() => {
    dispatch(GetAndSetBatchTypes())
    dispatch(GetAndSetBatches(1, throughDate))
  }, [throughDate])

  useEffect(() => {
    dispatch(SetSelectedBatches(selectedRows))
  }, [selectedRows])

  return (
    <React.Fragment>
      <SelectBox
        label="Batch Type"
        customCss="max-width: 250px"
        onChange={(e) => {
          setBatchType(e)
        }}
        options={batchTypes}
        noPlaceholder={batchTypes}
      />

      <div className="date-picker-holder">
        <TextInput
          label={'Batches Created Through'}
          placeholder="MM/DD/YYYY"
          customCss="max-width: 250px"
          onChange={(e) => {
            setThroughDate(e.target.value)
          }}
          value={throughDate}
        />
        <button
          className={`btn btn-primary picker-button`}
          aria-label={`Open calendar widget for Through Date`}
          onClick={() => setShowThroughDate(true)}
          style={{ marginTop: '14px' }}
        >
          <CalendarIcon size="small" />
        </button>
        <DatePicker
          isOpen={showThroughDate}
          onChange={(e) => {
            setThroughDate(format(new Date(e), 'MM/dd/yyyy'))
            setShowThroughDate(false)
          }}
          onCalendarClose={() => {
            setShowThroughDate(false)
          }}
        />
      </div>
      <div className='accounting-table'>
        <GraniteDataGrid
          columns={
            batches.length > 0 && batches[0].Amount != null
              ? tableColumnsBatches_AmountDisabled
              : tableColumnsBatches
          }
          rows={batches}
          pagination={undefined}
          rowsPerPageOptions={[25, 50, 100]}
          checkboxSelection={true}
          selectionModel={selectedRows}
          onSelectionModelChange={(ids) => {
            setSelectedRows(ids)
          }}
        />
      </div>
    </React.Fragment>
  )
}

export default PostPaymentBatch
